module.exports = __webpack_public_path__ + "img/H000150_goldenapple.ca59af5d.png";